import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";

import OpenChatBot from '~/components/layout/Chatbot';
import SideBar from '~/components/layout/Sidebar';
import Header from "~/components/layout/HeaderFaq";
import {
  Background,
  HeaderContainer,
  PageContainer
} from './styles';
import api from '~/services/api';
import { Widget } from './widget';

export default function Faq() {
  const location = useLocation();
  const dispatch = useDispatch();
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );
  const faqReducer = useSelector(
    state => state.faqReducer,
  );
  const stores = useSelector(state => state.economicGroupReducer.stores);
  const [loadWidget, setLoadWidget] = useState(false);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };
  const parameters = {
    headers: header,
  };

  useEffect(function () {
    if (loadWidget) {
      window.eHelpWidget.router.navigateTo("/");
    } else {
      setLoadWidget(true);
    }
  }, [faqReducer]);

  useEffect(function () {
    getUserByEmail();
  }, [localStorage.getItem('userCod')]);

  const getUserByEmail = () => {
    let url = `/residential/ultratop/v1/usuarios/codigo?userEmail=${localStorage.getItem(
      'userEmail',
    )}`;
    api
      .get(url, parameters)
      .then(res => {
        localStorage.setItem("userCod", res.data.data.user.user_cod)
        dispatch({ type: 'SET_USER_CODE', userCode: res.data.data.user.user_cod });
        window.eHelpWidget.ready(function () {
          window.eHelpWidget.setUser(res.data.data.user.user_cod);
        });
      })
      .catch(err => {
        if (err.response.status === 404) {
          const headerError = {
            'Content-Type': 'application/json',
            access_token: localStorage.getItem('access_token'),
          };
          const parametersError = {
            headers: headerError,
          };
          api
            .post(
              '/residential/ultratop/v1/usuarios',
              {
                userEmail: localStorage.getItem('userEmail'),
                resaleName: localStorage.getItem('storeName'),
                resaleSfId: localStorage.getItem('storeId')
              },
              parametersError,
            )
            .then(async res => {
              dispatch({ type: 'SET_USER_CODE', userCode: res.data.user_cod });
              window.eHelpWidget.ready(function () {
                window.eHelpWidget.setUser(res.data.user_cod);
              });
            })
            .catch(error => {
              toast.error(error.response.data.message);
            });
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  return (
    <SideBar
      menuSelected={'Universidade Ultragaz'}
      disabledOnMobile
      hasPendenciOn={classificationReducer.pendenciesOn}
    >
      <HeaderContainer>
        <div>
          <Header stores={stores} />
        </div>
      </HeaderContainer>
      <Background>
        <Widget />
      </Background>
      <OpenChatBot />
    </SideBar>
  );
}
